'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import AppLogo from '@/components/ui/AppLogo';
import { Zap, History } from 'lucide-react';

export default function Topbar() {
  const pathname = usePathname();

  return (
    <header className="relative z-20 w-full border-b border-border bg-background/80 backdrop-blur-md">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 2xl:px-16 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-2.5 group">
          <AppLogo size={32} />
          <span className="font-sans font-700 text-lg tracking-tight text-foreground group-hover:text-primary transition-colors duration-200">
            FrictionScan
          </span>
        </Link>

        {/* Right side */}
        <div className="flex items-center gap-3">
          <span className="hidden sm:flex items-center gap-1.5 text-xs font-mono text-muted-foreground bg-muted px-3 py-1.5 rounded-full border border-border">
            <Zap size={11} className="text-accent" />
            10 conversion signals
          </span>
          <Link
            href="/"
            className={`flex items-center gap-1.5 text-sm font-medium transition-colors duration-200 px-3 py-1.5 rounded-lg hover:bg-muted ${
              pathname === '/' ? 'text-foreground bg-muted' : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            Audit URL
          </Link>
          <Link
            href="/past-audits"
            className={`flex items-center gap-1.5 text-sm font-medium transition-colors duration-200 px-3 py-1.5 rounded-lg hover:bg-muted ${
              pathname === '/past-audits' ? 'text-foreground bg-muted' : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            <History size={14} aria-hidden="true" />
            <span className="hidden sm:block">Past Audits</span>
          </Link>
        </div>
      </div>
    </header>
  );
}